import type { PublicState } from '../../shared/protocol';
import { babelLang, bt } from '../../shared/babel/strings';
import { formatCountdown } from '../util/format';
import { useServerClock } from '../util/clock';

/** Active curse — both teams see it; the seeker is blocked from questioning.
 *  Carries only the curse identity + countdown (no location). */
export function CurseBanner({ state }: { state: PublicState }) {
  const now = useServerClock(state.timer.serverNow, [state.activeCurse?.endsAt]);
  const c = state.activeCurse;
  if (!c) return null;
  const isSeeker = state.you.role === 'seeker';
  // v5.5 §6: the seeker's Hold-Up is shown by the prominent StopBanner instead;
  // snail (and any other curse), and the hider's view, keep this banner.
  if (isSeeker && c.kind === 'holdup') return null;
  const left = Math.max(0, c.endsAt - now());
  return (
    <div className="curse-banner" data-testid="curse-banner">
      <div className="curse-banner__title">{c.label}</div>
      <div className="curse-banner__body">
        {/* v15 BOLT-054: the instruction now carries the whole rule ("No
            questions until it clears") — no bolted-on suffix. */}
        {/* v16 BOLT-071: the babel banner scrambles for the SEEKER only. */}
        {isSeeker ? (c.kind === 'babel' ? bt(babelLang(state), 'babelInstruction') : c.instruction) : bt(null, 'cardCast')} · <span className="t">{formatCountdown(left)}</span>
      </div>
    </div>
  );
}
